import { BuildingIcon } from '@phosphor-icons/react';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import useCustomer from 'src/api/accounts-receivable/customers/useCustomer';

interface CustomerPillProps {
  customer?: {
    name: string;
    erpDisplayName?: string | null;
    emailDomain?: string;
    phoneNumber?: string;
  };
  customerId?: string;
  onClick?: () => void;
  showERPDisplayName?: boolean;
}

const CustomerPill: React.FC<CustomerPillProps> = ({
  customer: providedCustomer,
  customerId,
  onClick,
  showERPDisplayName = false,
}) => {
  const { data: customerData, isLoading } = useCustomer(customerId, {});

  const customer = (providedCustomer ||
    customerData?.customer) as CustomerPillProps['customer'];

  const displayName =
    showERPDisplayName && customer
      ? (customer.erpDisplayName ?? customer.name)
      : customer?.name;

  if (isLoading || !customer) {
    return (
      <MDBox
        sx={{
          fontSize: 12,
          backgroundColor: 'rgba(26, 115, 232, 0.08)',
          borderRadius: '16px',
          padding: '4px 8px',
          width: 'fit-content',
        }}
      >
        <MDTypography color="info.main" sx={{ fontSize: 12 }}>
          Loading...
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <MDBox display="flex" alignItems="center" sx={{ cursor: 'default' }}>
      <MDBox
        display="flex"
        alignItems="center"
        gap={1}
        sx={{
          fontSize: 12,
          backgroundColor: 'rgba(26, 115, 232, 0.08)',
          color: 'info.main',
          borderRadius: '16px',
          padding: '4px 8px',
          width: 'fit-content',
          cursor: onClick ? 'pointer' : undefined,
          transition: 'all 0.2s ease-in-out',
          ...(onClick && {
            '&:hover': {
              backgroundColor: 'rgba(26, 115, 232, 0.16)',
              transform: 'translateY(-1px)',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            },
            '&:active': {
              transform: 'translateY(0)',
              boxShadow: 'none',
            },
          }),
        }}
        onClick={onClick}
      >
        <BuildingIcon size={16} />
        <MDTypography color="info.main" sx={{ fontSize: 12 }}>
          {displayName}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};

export default CustomerPill;
